import React from 'react';
import { useInjectReducer, useInjectSaga } from '../../utils/injectors';
import Reducer, { reducer, saga } from './Camera.reducer';

import classNames from "classnames";
import {
  Icon,
  IconButton,
} from '@mui/material';

import './Camera.scss';

const key = 'Camera';
const playerKey = 'CameraPlayer';

const Camera = props => {
  const {
    className,
    imageUrl,
    isOpen,

    capture,
    switchCamera,
    close,
  } = props;

  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });

  return (
    <section
      className={classNames(
        key,
        className,
        isOpen ? 'Opening' + key : 'hidden'
      )}
    >
      <div className='camera-player'>

        <video id={playerKey}></video>

        {
          isOpen &&
          <div className='player-overlay'>

            <div className='image-overlay'>
              {
                imageUrl &&
                <div className='image-view'>
                  <img src={imageUrl} alt="view" />
                </div>
              }
            </div>

            <div className='top-controls'>
              <IconButton
                onClick={switchCamera}
              >
                <Icon className='icon'>cameraswitch</Icon>
              </IconButton>

              <IconButton
                onClick={close}
              >
                <Icon className='icon'>close</Icon>
              </IconButton>
            </div>

            <div className='bottom-controls'>
              <IconButton
                onClick={capture}
              >
                <Icon className='icon'>camera</Icon>
              </IconButton>
            </div>

          </div>
        }

      </div>
    </section>
  );
};

export default Reducer.connector({
  isOpen: Reducer.makeSelector('isOpen'),
  stream: Reducer.makeSelector('stream'),
  imageUrl: Reducer.makeSelector('imageUrl'),
  player: Reducer.makeSelector('player'),
})(Camera);